var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "30px",
    viewBox: "0 0 28 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shopping-cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NAVBAR",
    transform: "translate(-1021.000000, -54.000000)",
    fill: "#092436",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav_cart",
    transform: "translate(1021.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87425429,23.1468611 C7.95481177,23.1468611 6.39344931,24.6838955 6.39344931,26.5734306 C6.39344931,28.4629656 7.95487129,30 9.87425429,30 C11.7936968,30 13.3550593,28.4625555 13.3550593,26.5734306 C13.3550593,24.6843057 11.7936968,23.1468611 9.87425429,23.1468611 Z M9.87425429,27.9024567 C9.13011914,27.9024567 8.52454954,27.3066742 8.52454954,26.5737821 C8.52454954,25.84089 9.13011914,25.2451076 9.87425429,25.2451076 C10.6187466,25.2451076 11.223959,25.84089 11.223959,26.5737821 C11.223959,27.3066742 10.6187466,27.9024567 9.87425429,27.9024567 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.519195,23.1468611 C20.5993954,23.1468611 19.0380329,24.6839541 19.0380329,26.5734306 C19.0380329,28.4629656 20.5994549,30 22.519195,30 C24.4382804,30 26,28.462907 26,26.5734306 C26,24.6839541 24.4382804,23.1468611 22.519195,23.1468611 Z M22.519195,27.9021051 C21.7747027,27.9021051 21.1691331,27.3059711 21.1691331,26.5734306 C21.1691331,25.84089 21.7747027,25.2451076 22.519195,25.2451076 C23.2633302,25.2451076 23.8688998,25.8405385 23.8688998,26.5734306 C23.8688998,27.3063227 23.2636873,27.9021051 22.519195,27.9021051 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34693802,22.0982653 L24.9340928,22.0982653 C25.5229964,22.0982653 25.9996429,21.628694 25.9996429,21.0493178 C25.9996429,20.4699417 25.5226393,20.0003704 24.9340928,20.0003704 L9.2530306,20.0003704 L6.20232645,1.5796886 C6.12917479,1.13841817 5.78038004,0.791601067 5.33319659,0.715018881 L1.24854813,0.0157010596 C0.66708466,-0.0836155476 0.116929385,0.298592257 0.0160408005,0.869179349 C-0.0852049121,1.4401766 0.303409584,1.98316598 0.883027896,2.08248258 L4.22068418,2.6538314 L7.29513732,21.2178338 C7.37941946,21.7259012 7.82446014,22.0982653 8.34693802,22.0982653 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8018264,6.4347275 C27.6075844,6.1614719 27.2982487,6 26.9685787,6 L6,6 L6,8.11538234 L25.554045,8.11538234 L23.4327629,14.8846177 L7.47812898,14.8846177 L7.47812898,17 L24.1845579,17 C24.6320865,17 25.0291537,16.7031115 25.1663098,16.2659616 L27.9506762,7.38128488 C28.0513687,7.05946364 27.9960109,6.7076286 27.8018264,6.4347275 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.92901f4bac7896b8238a70a6d202546e.svg";
export { ForwardRef as ReactComponent };